import {
  IChat,
  IFulfilledChat,
  MessageTypeNames,
  TAgeRange,
  TChatPartnerShort,
  TMessage
} from "../interfaces/interfacesChat";
import { TUserShort } from "../interfaces/interfaces";
import { parseServerDateTime, sortByCreationTime } from "./time";
import { calculateAge } from "./helpers";

export const getChatPartnerIdField = (userType: string) =>
  userType === "host" ? "student_id" : "host_id";

export const getChatMyIdField = (userType: string) =>
  userType === "host" ? "host_id" : "student_id";

export const getChatPartnerId = (chat: IChat, userType: string) => {
  return chat[getChatPartnerIdField(userType)];
};

export const getChatReadAtField = (userType: string) =>
  userType === "host"
    ? "host_most_recent_read_at"
    : "student_most_recent_read_at";

export const getChatRemoveByField = (userType: string) =>
  userType === "host" ? "removed_by_host" : "removed_by_student";

export const sortChatsByUpdateTime = (a: IFulfilledChat, b: IFulfilledChat) => {
  return parseServerDateTime(a.updated_at).getTime() <
    parseServerDateTime(b.updated_at).getTime()
    ? 1
    : -1;
};

export const sortChats = (chats: IFulfilledChat[]) => {
  return chats.sort(sortChatsByUpdateTime);
};

export const prepareChatMessages = (
  messages: TMessage[],
  userRole: string | null
) => {
  return messages
    .filter((m) => {
      return (
        m.msg_type !== MessageTypeNames.REMOVE_CHAT &&
        m.msg_type !== MessageTypeNames.UNREMOVE_CHAT &&
        !(
          userRole === "student" &&
          m.msg_type === MessageTypeNames.REVIEW_CREATED
        )
      );
    })
    .sort(sortByCreationTime);
};

export const defineAgeRange = (birthDate: string): TAgeRange => {
  const age: number = calculateAge(birthDate);

  if (age >= 18 && age < 21) return "18-20";
  if (age >= 21 && age < 26) return "21-25";
  if (age >= 26 && age <= 30) return "26-30";
  if (age > 30) return ">30";
  return null;
};

export const createFulfilledChats = (
  chats: IChat[],
  usersDescriptions: TUserShort[],
  currentUserType: string
): IFulfilledChat[] => {
  const usersMap = Object.fromEntries(
    usersDescriptions.map<[string, TChatPartnerShort]>((item: TUserShort) => [
      item.user_id,
      {
        ...item,
        first_name: item.first_name!,
        last_name: item.last_name!,
        thumbnail_url: item.thumbnail_url!,
        age_range: !!item.birth_date?.length
          ? defineAgeRange(item.birth_date)
          : null
      }
    ])
  );

  return chats
    .filter((chat) =>
      Boolean(usersMap[getChatPartnerId(chat, currentUserType)])
    )
    .map((chat) => {
      return {
        ...chat,
        conversation_partner_short:
          usersMap[getChatPartnerId(chat, currentUserType)]
      } as IFulfilledChat;
    });
};
